/**
 * Membership formatters — Indonesian Rupiah, status pills, expiry strings.
 */
export function rupiah(n) {
  if (n == null || Number.isNaN(Number(n))) return 'Rp —';
  const v = Math.round(Number(n));
  return `Rp ${v.toLocaleString('id-ID')}`;
}

export function formatDate(iso) {
  if (!iso) return '—';
  try {
    const d = new Date(iso);
    return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
  } catch {
    return String(iso).slice(0, 10);
  }
}

export function daysUntil(iso) {
  if (!iso) return null;
  try {
    const d = new Date(iso).getTime();
    const now = Date.now();
    return Math.ceil((d - now) / (1000 * 60 * 60 * 24));
  } catch { return null; }
}

export function expiryLabel(m) {
  if (!m?.expiry_date) return 'Lifetime';
  const n = daysUntil(m.expiry_date);
  if (n == null) return 'Active';
  if (n < 0) return `Expired ${formatDate(m.expiry_date)}`;
  if (n < 30) return `Expires in ${n} day${n === 1 ? '' : 's'}`;
  return `Active until ${formatDate(m.expiry_date)}`;
}

export const STATUS_PILL = {
  active:    { variant: 'green',  label: 'Active' },
  expired:   { variant: 'amber',  label: 'Expired' },
  cancelled: { variant: 'red',    label: 'Cancelled' },
};
